import React from 'react';
import PropTypes from 'prop-types';
import RxSpinnerComponent from '@Components/Results/utils/rx-spinner.component';
import AutosuggestInput from '@Components/AutosuggestInput';
import { SELECT_WRAP_SYMBOL, STOP_WORDS } from './QuickSearchAutosuggestConstants';

import './QuickSearchAutosuggest.theme.scss';

export default class Autosuggest extends React.PureComponent {
  constructor(props) {
    super(props);

    this._spinnerScale = 1;
    this._stopWords = [`${SELECT_WRAP_SYMBOL} `, ...STOP_WORDS.map((sw) => `${sw} `)];
    this._onSelectPreProcessor = (selected) => `${SELECT_WRAP_SYMBOL}${selected}${SELECT_WRAP_SYMBOL}`;
  }

  render() {
    const { inputValue, debounceDelay, fetchAutosuggestMatches, isLoading, inputOnChange, onSelect, buildQuery, placeholder } = this.props;
    return (
      <span className="react-qs-autosuggest">
        <AutosuggestInput
          idInput="id-quick-search-input"
          classNameInput="e2e-quick-search-input search-form-input els-text-input-field nohyphens"
          value={inputValue}
          onChange={inputOnChange}
          getData={fetchAutosuggestMatches}
          debounceDelay={debounceDelay}
          onSelect={onSelect}
          stopWords={this._stopWords}
          onSelectPreProcessor={this._onSelectPreProcessor}
          groupBy="category"
          highlight
          buildQuery={buildQuery}
          placeholder={placeholder}
        />
        {isLoading && <RxSpinnerComponent autoStart spinnerScale={this._spinnerScale} spinnerId="typeahead-spinner" />}
      </span>
    );
  }
}

Autosuggest.defaultProps = {
  debounceDelay: 150,
  inputValue: '',
};

Autosuggest.propTypes = {
  inputValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  debounceDelay: PropTypes.number,
  fetchAutosuggestMatches: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  inputOnChange: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  buildQuery: PropTypes.object,
  placeholder: PropTypes.string,
};
